export default __webpack_public_path__ + "static/media/logo-small.484a3bd9.png";